module.exports = __webpack_public_path__ + "img/imda.f745359d.png";